import { Routes, Navigate, Route } from "react-router-dom";
import { isEmpty } from "lodash";

import UserLayout from "./../../layouts/UserLayout/UserLayout";
import ProfileUser from "../../pages/User/ProfileUser/ProfileUser";
import ProfileUserContext from "../../context/UserContext/ProfileUserContext/ProfileUserContext";
import OrderUserContext from "../../context/UserContext/OrderUserContext/OrderUserContext";
import NotFoundPage from "../../pages/Page/NotFoundPage/NotFoundPage";
import { decodeJWT, getCookies } from "../../utils";
import { userRoleItems } from "../../utils/enum";
import OrdersCourier from "../../pages/Courier/OrdersCourier/OrdersCourier";

const CourierContainer = () => {
  const accessToken = getCookies("accessToken");

  const isLogin = !isEmpty(accessToken);

  const roleName = decodeJWT(accessToken)?.role;

  if (!isLogin || roleName !== userRoleItems[1])
    return <Navigate to="/" replace />;

  return (
    <UserLayout>
      <Routes>
        {/* Dashboard */}
        <Route
          index
          element={
            <ProfileUserContext>
              <ProfileUser />
            </ProfileUserContext>
          }
        />
        {/* Profile */}
        {["/profile", "/profile/changed-password", "/profile/settings"].map(
          (key) => (
            <Route
              key={key}
              path={key}
              element={
                <ProfileUserContext>
                  <ProfileUser />
                </ProfileUserContext>
              }
            />
          ),
        )}

        {/* Orders */}
        <Route
          path="/orders"
          element={
            <OrderUserContext>
              <OrdersCourier />
            </OrderUserContext>
          }
        />

        {/* Not Found */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </UserLayout>
  );
};

export default CourierContainer;
